<template>
  <div :style="'overflow-x: hidden;background:'+bgColor">	
      <div>
      		<div class="banner-c"><img :src="imageConfig.indexFirst"></div>
      </div>
	  <div class="crumbs-all">
		  <div class="crumbs-c" style="display: flex;" v-if="lang==='zh'"><div @click="$router.push('/'+lang)" style="cursor: pointer;" >首页</div> > 新闻中心</div>
		  <div class="crumbs-c" style="display: flex;" v-if="lang==='en'"><div @click="$router.push('/'+lang)" style="cursor: pointer;" >Home</div> > News</div>
		  <div class="crumbs-c" style="display: flex;" v-if="lang==='ja'"><div @click="$router.push('/'+lang)" style="cursor: pointer;" >最初のページ</div> > プレスセンター</div>
	  </div>
	  <div class="news-c content-bd" >
		<div class="f-l" :style="'background:'+font.newsCategoryBdColor+';font-weight:600;color:#000'">
			<ul>
				<!-- :style="'font-size:'+font.newsTitleSize" -->
				<li :class="{on:selectedType==0}" @click="selectedType=0;fetch()" >{{ lang |status1 }}<span></span></li>
				<li :class="{on:selectedType==1}" @click="selectedType=1;fetch()" >{{ lang |status }}<span></span></li>
			</ul>
		</div>
		<div class="f-r" :style="'background:'+font.newsRightBdColor+'margin-left:40px'">
			<div style="min-height: 600px;">
				<div v-for="(news,index) in newsList" style="padding: 10px 0 0 0; cursor: pointer;" @click="getDetail(news)" :key="index">
					<div class="l-title"  :style="'font-size:'+font.newsTitleSize+';color:'+font.newsTitleColor+';font-weight: 600'">{{news.newsTitle}} </div>
					<!-- <div class="l-content"  :style="'font-size:'+font.newsContentSize+';color:'+font.newsContentColor" v-html="news.newsContent"> </div> -->
					<div class="l-content">{{getTime(news.create_time)}}</div>
				</div>
			</div>				
			<div class="pageComponentsTest" style="margin: 0 auto;">
			    <!-- <page-component :page-config="pageConfigTotal" @changeCurrentPage="changePage"></page-component> -->
			    <page-component :page-config="pageConfigPageTotal" @changeCurrentPage="changePage"></page-component>
			</div>
		</div>
		<div class="clearfix"></div>
	  </div>
	  <p-bottom :lang="lang"></p-bottom>
  </div>
</template>

<script>
import pageComponent from "../components/pageComponent"	
export default {
  name: 'News',
  components:{'page-component':pageComponent},
  props:{
  		lang:{},
  },
  data() {
    return {
      isCompanyNews:true,
	  newsList:[],
	  selectedType:0,
	  pageConfigPageTotal:{
		  total:null,
		  pageSize:10,
		  pageNo:1,
		  pageTotal:null
	  },
	  imageConfig:{indexFirst:''},
	  font:{},
	  bgColor:'#fff'
    }
  },
  filters:{
	status(key){
		var map = {
			'zh':'行业新闻',
			'en':'Industry News',
			'ja':'業界ニュース',
		}
		return map[key]
	},
	status1(key){
		var map = {
			'zh':'公司新闻',
			'en':'Press Releases',
			'ja':'トピックス',
		}
		return map[key]
	}
  },
  methods: {
	handelBg(){
		if(localStorage.getItem('backgroudColor')){
			this.bgColor = JSON.parse(localStorage.getItem('backgroudColor')).newsBdColor
		}
	},
      async fetch(){
		  let data={
			  pageSize:10,
			  pageNo:this.pageConfigPageTotal.pageNo,
			  language:this.lang,
			  type:this.selectedType
		  }
      	  const res=await this.$http.post('newsList',data);
      	  this.newsList=res.data.list;
		  this.pageConfigPageTotal={
			  total:res.data.pageTotal,
			  pageSize:res.data.pageSize,
			  pageNo:res.data.pageNo,
			  pageTotal:res.data.pageAcount
		  }
      	  console.log(res)
      },
	  async getImage(){
			const res=await this.$http.get('imageConfig')
			this.imageConfig = res.data[0]||{}
		},
	  getTime(time){
	  	  const d=time;
	  	  const list=d.split(/[T.]/)
	  	   return list[0];
	  },
	  async getFontConfig(){
			const res = await  this.$http.post('fontConfig')
			const fontContent = res.data
			if(fontContent.length!==0){
				this.font = fontContent[0]
				
			}
	  },
	  getDetail(news){
		  localStorage.setItem('newsDetailData', JSON.stringify({id:news._id}))
		  this.$router.push("/newsDetail/"+this.lang)
	  },
	  changePage(page){
	      this.pageConfigPageTotal.pageNo = page;
		  this.fetch()
	  }
  },
  created(){
	  this.getImage()	
	  this.fetch()
	  this.getFontConfig()
	  this.handelBg()
  },
  watch: {
  			// 如果路由有变化，会再次执行该方法
  			"$route": "fetch"
  }
  
}
</script>
<style scoped>
	.news-c{
		background: #fff;	
	}
	.news-c .f-l{
		width: 300px;
		height: 430px;
		background: #333;
		margin-left: 56px;
		padding-top: 34px;
	}
	.banner-c{
		position: relative;
		width: 100%;
		height: 460px;
		overflow: hidden;
	}
	.banner-c img{
		position: absolute;
		left:0;
		width:1920px;
		margin:0 calc(50% - 960px);
	}
	.news-c .f-l ul li{
		font-size: 17px;
		height: 65px;
		line-height: 65px;
		color: #666;
		padding: 0 58px;
		cursor: pointer;
	}
	.news-c .f-l ul li.on{
		background: #fff;
	}
	.news-c .f-l ul li:hover{
		background: #fff;
	}
	.news-c .f-l ul li span{
		background: url('../assets/images/news_arrow.jpg');
		display: block;
		width: 21px;
		height: 21px;
		float: right;
		margin-top: 22px;
	}
	.news-c .f-r{
		width: 736px;
		margin: 29px 40px;
		float: left;
	}
	.news-c .f-r .l-title{
		font-size: 16px;
		color: #333;
		height: 28px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.news-c .f-r .l-content{
		font-size: 13px;
		color: #999;
		height: 21px;
		line-height: 20px;
		overflow: hidden;
	}
</style>